import { Skeleton } from '@/design-system/skeleton';

export const PreviewRowSkeleton = () => {
  return (
    <div className="flex gap-3.5 text-sm">
      <Skeleton className="w-[200px] h-4" />
      <Skeleton className="h-4 w-[220px]" />
    </div>
  );
};
